import React, { useCallback, useState, useRef, useEffect } from 'react';
import InputMask from 'react-input-mask';
import { toast } from 'react-toastify';
import { Modal, Button, Form, Spinner, Table } from 'react-bootstrap';
import PacienteInfo from '../../paciente/PacienteInfo';
import api from '../../../services/api';

const SearchPatientsModal = ({
  show,
  onHide,
  setIsAgendamento,
  nomePac,
  setNomePac,
  nomePacSearch,
  setNomePacSearch,
  codPacInicial = null,
  setCodPacInicial,
  onAgendar,
  loggedUser,
  isAgendamento,
  onFaturarAgenda,
}) => {
  const [pacientes, setPacientes] = useState([]);
  const [loadingPac, setLoadingPac] = useState(false);
  const [dtnNasc, setDtnNasc] = useState('');
  const [selectedPaciente, setSelectedPaciente] = useState(null);
  const [isNew, setIsNew] = useState(false);
  const [cpfBusca, setCpfBusca] = useState('');
  const [showNoPaciente, setShowNoPaciente] = useState(false);
  const dtnNascRef = useRef(null);

  useEffect(() => {
    if (show && dtnNascRef.current) {
      dtnNascRef.current.focus();
    }

    if (show) {
      // Só limpa nomePacSearch se for agenda existente
      if (codPacInicial && typeof setNomePacSearch === 'function')
        setNomePacSearch('');
      if (codPacInicial) {
        setIsNew(false);
        setSelectedPaciente(null);
      } else {
        setIsNew(true);
        setSelectedPaciente(null);
      }
    } else {
      setPacientes([]);
      setSelectedPaciente(null);
      setIsNew(false);
    }
  }, [show, codPacInicial, setNomePacSearch]);

  // TODO: buscamos o paciente em vários lugares. tem que parar de repetir isso! hooks ajudam!
  // TODO: aqui ainda preciso melhorar. tá confuso!
  const handlePaciente = useCallback((value, searchType) => {
    let trimmed = value && value.trim();
    if (searchType === 'nome' && (!trimmed || trimmed.length < 3)) {
      return toast.warn('Digite pelo menos 3 letras!');
    }
    if (searchType === 'dtNasc' && !trimmed) return;
    if (searchType === 'cpf') {
      if (!trimmed || trimmed.length < 11) {
        return toast.warn('Digite o CPF completo!');
      }
    }

    let params = {};
    if (searchType === 'nome') params = { nome: trimmed };
    else if (searchType === 'dtNasc') params = { dtNasc: trimmed };
    else if (searchType === 'cpf') params = { cpf: trimmed };

    setLoadingPac(true);
    api
      .get('/pacientes', { params })
      .then(result => {
        setPacientes(result.data);

        if (result.data.length === 1) {
          setSelectedPaciente(result.data[0]);
          setIsNew(false);
          setShowNoPaciente(false);
        } else if (result.data.length > 1) {
          setShowNoPaciente(false);
        } else {
          setSelectedPaciente(null);
          setIsNew(true);
          if (typeof setNomePacSearch === 'function') setNomePacSearch(null);
          setShowNoPaciente(true); // Exibe mensagem de não encontrado
        }
      })
      .catch(err => {
        toast.error(err?.response?.data?.error || 'Erro ao buscar pacientes');
      })
      .finally(() => setLoadingPac(false));
  }, []);

  const handleSelectPaciente = useCallback(pac => {
    setSelectedPaciente(pac);
    setIsNew(false);
    setPacientes([]);
  }, []);

  const handleNovo = useCallback(() => {
    setSelectedPaciente(null);
    setPacientes([]);
    setIsNew(true);
    if (typeof setNomePac === 'function') setNomePac('');
    if (typeof setNomePacSearch === 'function') setNomePacSearch('');
    if (typeof setCodPacInicial === 'function') setCodPacInicial(null);
    setDtnNasc('');
    setCpfBusca('');
    setShowNoPaciente(false);
  }, [setNomePac, setNomePacSearch, setCodPacInicial]);

  const handleCreated = useCallback(
    pac => {
      if (pac && pac.CODPAC) {
        setSelectedPaciente(pac);
        setIsNew(false);
        setCodPacInicial && setCodPacInicial(pac.CODPAC);
        if (codPacInicial === 1 && setNomePac) setNomePac(pac.NOMEPAC || '');
        setShowNoPaciente(false);
      }
    },
    [codPacInicial, setCodPacInicial, setNomePac]
  );

  return (
    <Modal
      show={show}
      onHide={() => {
        if (typeof setIsAgendamento === 'function') setIsAgendamento(false);
        onHide();
      }}
      size="xl"
    >
      <Modal.Header closeButton className="font-weight-bold">
        PACIENTE
      </Modal.Header>
      <Modal.Body>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8 }}>
          <div style={{ flexDirection: 'column', flex: 1 }}>
            <Form.Label className="font-weight-bold mb-0">Nome</Form.Label>
            <Form.Control
              style={{ textTransform: 'uppercase' }}
              value={
                codPacInicial === 1
                  ? nomePac === 'NULO'
                    ? ''
                    : nomePac || ''
                  : nomePacSearch || ''
              }
              required
              type="text"
              onChange={e => {
                // Só permite alterar nomePac se for novo paciente (codPacInicial === 1)
                if (codPacInicial === 1) {
                  setNomePac(e.target.value);
                } else if (typeof setNomePacSearch === 'function') {
                  setNomePacSearch(e.target.value);
                }
                setDtnNasc('');
                setCpfBusca('');
                setSelectedPaciente(null);
                setIsNew(true);
                setShowNoPaciente(false);
              }}
              onKeyUp={e =>
                e.key === 'Enter' &&
                handlePaciente(
                  codPacInicial === 1 ? nomePac : nomePacSearch,
                  'nome'
                )
              }
            />
          </div>
          <div style={{ flexDirection: 'column' }}>
            <Form.Label className="font-weight-bold mb-0">
              Data de nascimento
            </Form.Label>
            <Form.Control
              ref={dtnNascRef}
              value={dtnNasc || ''}
              type="date"
              onChange={e => {
                setDtnNasc(e.target.value);
              }}
              onPaste={e => {
                const clipboard = e.clipboardData.getData('text').trim();
                let match = clipboard.match(
                  /^(\d{2})[/.-](\d{2})[/.-](\d{4})$/
                );
                if (match) {
                  e.preventDefault();
                  const [, dd, mm, yyyy] = match;
                  setDtnNasc(`${yyyy}-${mm}-${dd}`);
                  return;
                }
                match = clipboard.match(/^(\d{4})[/.-](\d{2})[/.-](\d{2})$/);
                if (match) {
                  e.preventDefault();
                  setDtnNasc(clipboard);
                }
              }}
              onKeyUp={e =>
                e.key === 'Enter' && handlePaciente(dtnNasc, 'dtNasc')
              }
            />
          </div>
          <div style={{ flexDirection: 'column' }}>
            <Form.Label className="font-weight-bold mb-0">CPF</Form.Label>
            <InputMask
              mask="999.999.999-99"
              value={cpfBusca || ''}
              onChange={e => {
                setCpfBusca(e.target.value);
                setNomePac('');
                setDtnNasc('');
                setSelectedPaciente(null);
                setIsNew(true);
                setShowNoPaciente(false);
                if (typeof setCodPacInicial === 'function')
                  setCodPacInicial(null);
              }}
            >
              {inputProps => (
                <Form.Control
                  {...inputProps}
                  type="text"
                  placeholder="000.000.000-00"
                  onKeyUp={e =>
                    e.key === 'Enter' && handlePaciente(cpfBusca, 'cpf')
                  }
                />
              )}
            </InputMask>
          </div>
          <div style={{ display: 'flex', gap: 4 }}>
            <Button
              onClick={() => {
                if (nomePac && nomePac.trim().length >= 3) {
                  handlePaciente(nomePac, 'nome');
                } else if (dtnNasc) {
                  handlePaciente(dtnNasc, 'dtNasc');
                } else if (cpfBusca && cpfBusca.length >= 11) {
                  handlePaciente(cpfBusca, 'cpf');
                } else {
                  toast.warn(
                    'Preencha o nome (mín. 3 letras), a data ou o CPF.'
                  );
                }
              }}
              disabled={loadingPac}
            >
              {loadingPac ? (
                <Spinner animation="border" variant="dark" size="sm" />
              ) : (
                'Localizar'
              )}
            </Button>
          </div>
        </div>

        {pacientes.length > 1 && (
          <div className="mt-3">
            <p className="font-weight-bold mb-2">
              {pacientes.length} pacientes encontrados — selecione um:
            </p>
            <div style={{ maxHeight: 300, overflowY: 'auto' }}>
              <Table hover size="sm" variant="success" className="mb-0">
                <thead>
                  <tr>
                    <th>Código</th>
                    <th>Nome</th>
                    <th>Dt Nasc</th>
                    <th>Celular</th>
                    <th>CPF</th>
                  </tr>
                </thead>
                <tbody>
                  {pacientes.map(pac => (
                    <tr
                      key={pac.CODPAC}
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleSelectPaciente(pac)}
                      onKeyDown={e => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          handleSelectPaciente(pac);
                        }
                      }}
                      tabIndex={0}
                      role="button"
                      aria-label={`Selecionar paciente ${pac.NOMEPAC}`}
                    >
                      <td>{pac.CODPAC}</td>
                      <td>{pac.NOMEPAC}</td>
                      <td>{pac.dataFormatada}</td>
                      <td>{pac.CELULARPAC}</td>
                      <td>{pac.ENDMARPAC}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        )}

        {showNoPaciente && (
          <div
            style={{
              color: 'red',
              fontWeight: 'bold',
              textAlign: 'center',
              marginBottom: 8,
              marginTop: 16,
            }}
          >
            Nenhum paciente localizado. Preencha os dados para novo cadastro.
          </div>
        )}

        {/* Formulário de edição/criação */}
        <div style={{ marginTop: 16 }}>
          <PacienteInfo
            key={isNew ? 'novo' : selectedPaciente?.CODPAC || codPacInicial}
            codPac={selectedPaciente?.CODPAC || codPacInicial || null}
            isCreation={isNew}
            isAgendamento={isAgendamento}
            loggedUser={loggedUser || null}
            onAgendar={onAgendar}
            onCreated={handleCreated}
            onAbrirPaciente={handleSelectPaciente}
            onNovo={handleNovo}
            onFaturarAgenda={onFaturarAgenda}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SearchPatientsModal;
